import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { TopTabsNav } from './TopTabsNav';
import { BottomTabsNav } from './BottomTabsNav';
import { FloatingPillNav } from './FloatingPillNav';
import { useAuth } from '../../hooks/useAuth';
import { NavigationLayout } from '../../types';

export const MainLayout: React.FC = () => {
  const { user } = useAuth();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const layoutStyle = user?.navigationLayout || NavigationLayout.SIDEBAR;

  return (
    <div className="flex h-screen bg-transparent text-text-main overflow-hidden">
      {/* Render sidebar for SIDEBAR style or when explicitly toggled in mobile */}
      {(layoutStyle === NavigationLayout.SIDEBAR || isSidebarOpen) && (
        <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />
      )}

      <div className="flex-1 flex flex-col overflow-hidden relative">
        <Header onToggleSidebar={() => setIsSidebarOpen(prev => !prev)} />

        {/* TOP_TABS Header Bar */}
        {layoutStyle === NavigationLayout.TOP_TABS && <TopTabsNav />}

        <main className={`flex-1 overflow-x-hidden overflow-y-auto bg-transparent p-3 sm:p-5 lg:p-8 ${
          layoutStyle === NavigationLayout.BOTTOM_TABS || layoutStyle === NavigationLayout.FLOATING_PILL ? 'pb-24 sm:pb-28' : ''
        }`}>
          <Outlet />
        </main>

        {/* BOTTOM_TABS Navigation Bar */}
        {layoutStyle === NavigationLayout.BOTTOM_TABS && <BottomTabsNav />}

        {/* FLOATING_PILL Navigation Bar */}
        {layoutStyle === NavigationLayout.FLOATING_PILL && <FloatingPillNav />}
      </div>
    </div>
  );
};
